import React, { useEffect, useState, useRef } from "react";
import CardImage from "../../atoms/card-image";
import VisualStoryModal from "../visual-story-modal";
import "./visual-story.m.css";

// VisualStory component definition
const VisualStory = ({visibleItems = 3}) => {
  const [visualStoryCategory, setVisualStoryCategory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);

useEffect(() => {
  async function fetchAPI() {
    try {
      const response = await fetch(`/api/v1/collections/visual-story`);
      const json = await response.json();

      //filter stories without main image
      const filteredItems = json.items.filter(item => item.story['hero-image-s3-key']);

      setVisualStoryCategory(filteredItems);
    } catch (error) {
      console.error("Error fetching visual stories:", error);
    }
  }
  fetchAPI();
}, []);

/**
 * visibleItems:
 * Controls how many visual story items are displayed.
 *
 * Behavior:
 * - visibleItems defines the number of items shown.
 * - Specific grid styles exist for selected counts (e.g. 3 or 6).
 * - Other counts use the default grid style.
 *
 * Note:
 * - The number of visible items and the number of grid columns can differ.
 * - Example: visibleItems = 5 shows 5 items but uses the default grid layout.
 * - If you use some other number than 3 or 6, check also styles and add number to supportedCounts.
 */

const getGridClass = (visibleItems) => {
  const supportedCounts = [3, 6];
  if (supportedCounts.includes(visibleItems)) {
    return `columns-${visibleItems}`;
  }
  return 'default';
};

  const visualStoryTopics = [...visualStoryCategory || []];

  if (visualStoryTopics.length < 1) {
    return null;
  }

  const handleLinkClick = (index) => {
    const story = visualStoryTopics[index].story;
    setCurrentStoryIndex(index);
    setModalContent(<iframe src={story.url} width="100%" height="100%" />);
    setIsModalOpen(true);
  };

  const handleNextStory = () => {
    const nextIndex = (currentStoryIndex + 1) % visualStoryTopics.length;
    handleLinkClick(nextIndex);
  };

  const handlePreviousStory = () => {
    const prevIndex = (currentStoryIndex - 1 + visualStoryTopics.length) % visualStoryTopics.length;
    handleLinkClick(prevIndex);
  };

  return (
    <React.Fragment>
      <div styleName="visual-story">
        <div styleName="title-line" className="">
          <div styleName="hr-style" className="horizontal-line" />
          <div styleName="category-title" className="category">I-P lyhyet</div>
        </div>
        <div styleName={`visual-story-container ${getGridClass(visibleItems)}`}>
          {visualStoryTopics.filter(item => item.story['hero-image-s3-key']).slice(0, visibleItems).map((item, index) => (
              <div
                key={index}
                styleName="visual-story-item"
                onClick={() => handleLinkClick(index)}
              >
                <CardImage
                  story={item.story}
                  defaultWidth={183}
                  aspectRatio={[3, 4]}
                  imageType="image9x16"
                />
                <div styleName="play-button-bg">
                  <i className="ri-play-fill" styleName="play-icon"></i>
                </div>
                <div styleName="visual-story-title"><h2>{item.story.headline}</h2></div>
              </div>
          ))}
        </div>
      </div>

      <VisualStoryModal
        show={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        closePopup={() => setIsModalOpen(false)}
        onNext={handleNextStory}
        onPrevious={handlePreviousStory}
        currentStoryIndex={currentStoryIndex}
      >
        {modalContent}
      </VisualStoryModal>
    </React.Fragment>
  );

};

export default VisualStory;
